<template>
  <div class="button-background">
    <button class="button-area top-item" @click="startPatientSession()">
      <span class="button-text">
        <img
          class="button-image"
          src="../assets/heart.png"
          alt="start session"
          style="float: left"
        />
        <p class="button-text-style">
          Start a new patient blood pressure monitoring session.
        </p>
      </span>
    </button>
    <button class="button-area bottom-item" @click="openConfigMode()">
      <span class="button-text">
        <img
          class="button-image"
          src="../assets/monitor.png"
          alt="start session"
          style="float: left"
        />
        <p class="button-text-style">Configure Hypotension Decision Assist</p>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'LaunchscreenButtons',
  methods: {
    startPatientSession() {
      this.$emit('start-patient-session')
    },
    openConfigMode() {
      this.$emit('open-config-mode')
    }
  }
}
</script>

<style scoped>
button:focus {
  outline: none;
}
.top-item {
  grid-row: 1;
  grid-column: 2;
  float: left;
}
.bottom-item {
  grid-row: 2;
  grid-column: 2;
  float: left;
}
.button-background {
  background: #5bae9f;
  height: 98%;
  padding: 1% 0 1% 0;
  display: grid;
  grid-template-rows: 49% 49%;
  grid-template-columns: 12% 76% 12%;
  border-radius: 21px;
  grid-row-gap: 2%;
}
.button-area {
  background-color: transparent;
  border: none;
}
.button-text {
  display: flex;
  align-items: center;
  justify-content: left;
  height: 100%;
  width: 100%;
}
.button-image {
  height: 96%;
}
.button-text-style {
  color: white;
  font-size: 1.3vw;
  margin-left: 5%;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: left;
}
</style>
